import { Component, OnInit } from '@angular/core';
import { routerFadeAnimation } from '@simpl/newton-ng/tools';
import { UserManagementService } from './services/user-management.service';
import { ProjectManagementService } from './services/project-management.service';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  animations: [routerFadeAnimation]
})
export class AppComponent implements OnInit {
  title = 'app';
  version = 'Loading...';

  constructor(
    public userManagementService: UserManagementService,
    public projectManagementService: ProjectManagementService
  ) {
    console.log('AppComponent constructor called');
  }

  ngOnInit(): void {
    console.log('AppComponent ngOnInit called');
    this.loadVersion();
  }

  private loadVersion(): void {
    console.log('Loading version info from backend...');
    // Use fetch instead of HttpClient to bypass Auth0 interceptor
    fetch(`${environment.baseUrl}/health/info`)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then((data) => {
        this.version = data.version || 'Unknown';
        console.log('Version loaded:', this.version);
      })
      .catch((error) => {
        console.error('Failed to load version:', error);
        this.version = 'Unknown';
      });
  }

  public searchChanged(searchTerm: string): void {
    console.log('Searching for Sugar Man: ', searchTerm);
  }

  getRouteAnimation(outlet: any): any {
    try {
      return outlet && outlet.isActivated ? outlet.activatedRoute : '';
    } catch (error) {
      console.warn('Route animation error:', error);
      return '';
    }
  }
}
